import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconLogoIdeal = function IconLogoIdeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 36"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-logo-ideal_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 2.629v30.206c0 1.446 1.176 2.629 2.614 2.629h17.941C34.12 35.464 40 27.827 40 17.693 40 7.61 34.12 0 20.555 0H2.614C1.176 0 0 1.183 0 2.629"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C06",
    d: "M12.01 7.413v22.32h9.656c8.769 0 12.571-4.982 12.571-12.027 0-6.743-3.803-11.975-12.57-11.975h-7.985a1.68 1.68 0 0 0-1.673 1.682"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.555 33.058H4.953a2.517 2.517 0 0 1-2.51-2.523V4.942a2.517 2.517 0 0 1 2.51-2.524h15.602c14.806 0 17.014 9.583 17.014 15.288 0 9.897-6.05 15.352-17.014 15.352M4.953 3.26c-.928 0-1.673.749-1.673 1.682v25.593c0 .933.745 1.682 1.673 1.682h15.602c10.428 0 16.178-5.153 16.178-14.511 0-12.567-10.14-14.446-16.178-14.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.407 14.696c.34 0 .653.052.954.157.3.105.549.276.77.487.21.223.38.5.51.815.118.328.183.71.183 1.156 0 .395-.052.75-.143 1.078a2.521 2.521 0 0 1-.445.855 2.16 2.16 0 0 1-.744.565c-.301.131-.654.21-1.059.21h-2.287v-5.337h2.26zm-.079 4.35c.17 0 .327-.026.497-.078a.974.974 0 0 0 .418-.276c.118-.132.222-.29.3-.5.08-.21.118-.447.118-.75a3.06 3.06 0 0 0-.078-.722 1.44 1.44 0 0 0-.261-.552 1.179 1.179 0 0 0-.47-.355 1.913 1.913 0 0 0-.72-.119h-.836v3.365h1.033zm7.214-4.35v.985h-2.797v1.144h2.575v.907h-2.575v1.301h2.862v.986h-4.024v-5.337h3.959zm3.998 0 1.987 5.336H27.31l-.405-1.183H24.92l-.418 1.183h-1.176l2-5.336zm.066 3.272-.667-1.958h-.013l-.692 1.958zm3.816-3.272v4.35h2.587v.986h-3.75v-5.336z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.644 19.822a2.45 2.45 0 0 0 2.444-2.458 2.45 2.45 0 0 0-2.444-2.458 2.45 2.45 0 0 0-2.443 2.458 2.45 2.45 0 0 0 2.443 2.458m1.843 9.911c-2.051 0-3.698-1.67-3.698-3.72v-2.905a1.86 1.86 0 0 1 1.856-1.866A1.86 1.86 0 0 1 9.5 23.108v6.625z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-logo-ideal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v35.464H0z"
  }))));
};